import { useAuth, useAuthUpdate } from "context/AuthContext";
import { useNotifications } from "context/NotificationContext";
import { Bell } from "lucide-react";
import React, { useState } from "react";
import { LoginAccount } from "types";
import personImg from "../images/person.png";
import PopupNotification from "./PopupNotification";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

interface User {
  name: string;
  username: string;
  role: string;
  avatar?: string;
  email: string;
}
interface NavItems {
  name: String;
  href: string;
}
type HeaderProps = {
  isInternalUser: boolean;
};
export interface JwtPayload {
  exp?: number; // Expiration time in seconds
  iat?: number; // Issued at
  sub?: string; // Subject (user id, etc.)
  [key: string]: any; // Any additional claims
}

const Header: React.FC<HeaderProps> = ({ isInternalUser }) => {
  // ✅ In a real app, this would come from context or Redux
  const { loginData } = useAuth();
  const { t } = useTranslation();

  const isMember = sessionStorage.getItem("access_token") === "Member";
  // console.log(sessionStorage.getItem("access_token"));

  const [tokenLoaded, setTokenLoaded] = useState(false);
  const updateAuthContext = useAuthUpdate();

  const handleLogout = () => {
    sessionStorage.removeItem("access_token");
    updateAuthContext({
      loginData,
      token: "",
      isAuthenticated: false,
      setLoginData: function (token: LoginAccount | null): void {
        throw new Error("Function not implemented.");
      },
      logout: function (): void {
        throw new Error("Function not implemented.");
      },
    });
    window.location.href = "/login";
  };

  const [logoutBtn, setLogoutBtn] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { unreadCount } = useNotifications();

  console.log(loginData);

  const currentUser: User = {
    name:
      loginData?.full_name ||
      (loginData?.full_name ? `${loginData.full_name} ` : "") ||
      "",
    username: loginData?.user?.username || loginData?.user?.username || "",
    role:
      loginData?.roles && loginData?.roles?.length > 1
        ? loginData?.roles[1]
        : loginData?.roles?.length
          ? loginData.roles[0]
          : "User", // Default to 'User' if no roles are defined
    email: loginData?.email || loginData?.email || "",
    avatar: personImg, // default for now, can be updated after login
  };

  // const navigationItems: NavItems[] = [
  //   { name: "Home", href: "#home" },
  //   { name: "About", href: "#about" },
  //   { name: "Jobs", href: "#jobs" },
  //   { name: "Request", href: "#request" },
  //   { name: "FAQ", href: "#faq" },
  // ];

  if (!isMember)
    return renderInsideUserHeader(
      currentUser,
      handleLogout,
      logoutBtn,
      setLogoutBtn,
      unreadCount,
      showNotification,
      setShowNotification,
    );
  return <></>;
};

const renderInsideUserHeader = (
  user: User,
  handleLogout: any,
  logoutBtn: boolean,
  setLogoutBtn: any,
  unreadCount: any,
  showNotification: boolean,
  setShowNotification: React.Dispatch<React.SetStateAction<boolean>>,
) => (
  <header className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200 shadow-sm">
    {/* Title section */}
    <div className="flex items-center gap-3">
      <div className="h-10 border-l-4 border-red-600" />
      <div className="leading-tight">
        <div className="text-lg font-semibold text-gray-800">
          Complaint System
        </div>
        <div className="text-sm font-medium text-red-600">
          B.A.A.W.O. System
        </div>
      </div>
    </div>

    {/* Right user info */}
    {/* user icon  */}
    <div className="flex gap-4 ml-auto mr-8">
      <select
        value={i18n.language}
        onChange={(e) => {
          const lang = e.target.value;
          i18n.changeLanguage(lang);
          localStorage.setItem("lang", lang);
        }}
        className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-gray-100 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
      >
        <option value="en">🌐 English</option>
        <option value="or">🌐 Afaan Oromoo</option>
        <option value="am">🌐 አማርኛ</option>
        
      </select>
      <button
        onClick={() => setShowNotification(!showNotification)}
        className={`relative p-2 rounded-lg hover:bg-gray-200 ${
          showNotification ? "bg-gray-300" : "bg-gray-100"
        }`}
      >
        <Bell className="text-gray-700" />
        {unreadCount >= 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
            {unreadCount}
          </span>
        )}
      </button>
    </div>
    <div className="flex items-center gap-2 relative">
      <div
        className="hidden sm:block text-right"
        onClick={() => setLogoutBtn(!logoutBtn)}
      >
        <div className="text-base font-semibold text-[#0A1D39]">
          {user.name}
        </div>
        <div className="text-sm font-normal text-[#432101]">{user.role}</div>
      </div>

      <div className="flex gap-3 relative">
        <img
          src={user.avatar}
          alt="User Avatar"
          width={32}
          height={32}
          className="object-cover rounded-full"
        />
        <div className="my-auto">
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5 8L0.669872 0.499999L9.33013 0.5L5 8Z" fill="#D9D9D9" />
          </svg>
        </div>
      </div>

      {showNotification && <PopupNotification />}
    </div>
    {/* user icon  */}
  </header>
);

export default Header;
